import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Carousel } from 'react-bootstrap'
import '../../styles/components/BannerStyle.scss'
import Calculator from '../Calculator/Calculator'
import BannerItem from './BannerItem'
import config from '../../config/cms'

const Banner = ({
  bannerData = [],
  productId = undefined,
  productRef = undefined,
  showSlogan = true,
  appLinks = undefined
}) => {
  const bannerRef = useRef()
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    document.body.classList.add('has-banner')
    const handleScroll = () => {
      const { element } = bannerRef?.current || {}
      const positionEnd = (element?.clientTop || 0) + (element?.clientHeight || 0)
      if (window.scrollY < positionEnd) {
        document.body.classList.add('has-banner')
      } else {
        document.body.classList.remove('has-banner')
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      document.body.classList.remove('has-banner')
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleSelect = (selectedIndex) => {
    setCurrentSlide(selectedIndex)
  }

  return (
    <section
      className={`slider-wrapper position-relative mb-3 ${bannerData.length > 0 ? 'with-banners' : 'without-banners'}`}
    >
      <div className="bannerWrapper">
        <Carousel
          controls={false}
          indicators={false}
          touch
          wrap
          pause={false}
          ref={bannerRef}
          onSelect={handleSelect}
        >
          {bannerData?.map((slide, index) => {
            const imgUrl = slide.image?.url
            return (
              <Carousel.Item
                interval={10000}
                key={slide.id}
                style={{ backgroundImage: imgUrl ? `url(${config.url + imgUrl})` : 'none' }}
              >
                <BannerItem
                  slideProps={slide}
                  productRef={productRef}
                  isActive={currentSlide === index}
                  showSlogan={showSlogan}
                  appLinks={appLinks}
                />
              </Carousel.Item>
            )
          })}
        </Carousel>
        <div className="move-down">
          <i className="material-icons text-white">expand_circle_down</i>
        </div>
      </div>
      {bannerData.some((slide) => slide.showCalculator) && (
        <div className="calculator-container px-3 pe-lg-0">
          <div className="h-100 d-flex align-items-center pb-md-3 pt-md-4 py-lg-5 calculator-box">
            <Calculator pageProductId={productId} />
          </div>
        </div>
      )}
    </section>
  )
}

Banner.propTypes = {
  bannerData: PropTypes.instanceOf(Array),
  productId: PropTypes.number,
  productRef: PropTypes.instanceOf(Object),
  showSlogan: PropTypes.bool,
  appLinks: PropTypes.instanceOf(Array)
}

export default Banner
